import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Button, Box, IconButton } from '@mui/material';
import { useParams } from 'react-router-dom';
import DiagnosisReport from './DiagnosisReport';
import { getDiagnosisInfo, Diagnosis } from './reportHelper';
import { generatePDF } from '../../../../../utils/reportUtils';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

type DiagnosisPDFDialogProps = {
  open: boolean;
  onClose: () => void;
};

const DiagnosisPDFDialog: React.FC<DiagnosisPDFDialogProps> = ({ open, onClose }) => {
  const reportRef = useRef<HTMLDivElement>(null);
  const { id } = useParams();
  const [diagnosisList, setDiagnosisList] = useState<Diagnosis[]>([]);

  useEffect(() => {
    if (open && id) {
      getDiagnosisInfo(`patient_id=${id}`).then((data) => {
        setDiagnosisList(data?.objects || []);
      });
    }
  }, [open, id]);

  const handleDownloadPDF = () => {
    if (reportRef.current) {
      generatePDF(reportRef.current, 'Diagnosis_Report');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>Diagnosis Report</span>
          <Box display="flex" alignItems="center" gap={1}> {/* Increased gap */}
            <Button
              variant="contained"
              onClick={handleDownloadPDF}
              sx={{
                backgroundColor: '#404040', // Dark black background
                color: 'white', // White text
                '&:hover': {
                  backgroundColor: '#505050', // Darker shade for hover effect
                },
                display: 'flex',
                alignItems: 'center', // Align text and icon properly
                gap: 1, // Space between icon and text
                textTransform: 'capitalize',
              }}
            >
              <DownloadIcon sx={{ color: 'white' }} />
              Download Report
            </Button>
            
            <IconButton onClick={onClose} aria-label="close" sx={{ ml: 2 }} >        
              <HighlightOffIcon />              
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div ref={reportRef}>
          {diagnosisList.length > 0 && <DiagnosisReport diagnoses={diagnosisList} />}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DiagnosisPDFDialog;
